<template>
  <mobialisCard class="mb-2 pb-3">
    <h2 class="custom-padding-right mt-0">{{ $t('message.insurance.rates.title') }}</h2>
    <div class="d-flex quote mt-4" v-for="(quote, index) in insuranceQuotes" :key="index">
      <div class="logo d-flex">
        <template v-if="getThisIsAmerica">
          <img :src="quote.InsuranceCompanyImageUrl" :alt="quote.InsuranceCompany" />
        </template>
        <template v-else>
          <img width="70px" :src="imageSrc[quote.InsuranceCompany]" :alt="quote.InsuranceCompany" />
        </template>
      </div>
      <div>
        <p data-cy="quote" class="font-weight-bold mt-0">{{ getPaymentRateString(quote) }}</p>
        <template v-if="getThisIsAmerica">
          {{ quote.InsuranceCompany }} {{ $t('message.insurance.insuranceWrapperHeader') }}
        </template>
        <template v-else>
          <p class="mt-0">{{ $t(`message.insurance.rates.${quote.InsuranceCompany.toLowerCase()}`) }}</p>
        </template>
      </div>
    </div>
  </mobialisCard>
</template>

<script>
import HorizontalRates from './HorizontalRates.vue';

export default {
  name: 'VerticalRates',
  extends: HorizontalRates,
  methods: {
    getPaymentRateString(quote) {
      let string;

      string = `${this.$n(
        quote.Annual,
        'currencyDollars',
        this.getLanguageCodeForNumericalInternationalization
      )}/${this.$t('message.common.year')}`;

      if (quote.MonthlyPayment) {
        string = `${string} ${this.$t('message.common.or')} ${this.$n(
          quote.MonthlyPayment,
          'currencyDollars',
          this.getLanguageCodeForNumericalInternationalization
        )}/${this.$t('message.common.month')}`;
      }

      return string;
    },
  },
};
</script>
<style lang="scss" scoped>
h2 {
  font-size: 20px;
  font-weight: bold;
}
p {
  margin-bottom: 0px;
  color: rgb(25, 34, 43);
}
img {
  max-height: 100%;
  max-width: 100%;
  margin: 0 auto;
}
.logo {
  height: 48px;
  width: 68px;
  padding-right: 10px;
  margin-right: 20px;
}
.quote {
  height: 48px;
  width: 290px;
}
.custom-padding-right {
  padding-right: 70px;
}
</style>
